import rules from './rules';
import increaseColorPointByStep from './common/utils/increase-color-point-by-step';
import reduceColorPointByStep from './common/utils/reduce-color-point-by-step';
import findColorShadeInPalette from './common/utils/find-color-shade-in-palette';

const utils = {
  increaseColorPointByStep,
  reduceColorPointByStep,
  findColorShadeInPalette,
};

export { rules };
export { utils };
